import React, { FC } from "react";
import InfoCard from "../../Cards/InfoCard";

interface InfoSectionProps {}

const dummyData = [
  {
    icon: "deposit.svg",
    title: "Deposit",
    description:
      "Deposit USDT from any crypto wallet into GetFuture’s main wallet. Your balance here is fixed.",
  },
  {
    icon: "send.svg",
    title: "Send Up or Down",
    description:
      "Send money to your up or down wallet, depending on how you foresee bitcoin’s price movement. Your wallets simplifies futures trades made in the backend, which enables you earn in either direction.",
  },
  {
    icon: "withdraw.svg",
    title: "Withdraw Earnings",
    description:
      "When the price moves either up or down, you get your earnings in the corresponding wallet. Withdraw at anytime.",
  },
];

const InfoSection: FC<InfoSectionProps> = () => {
  return (
    <div className="mx-8 xl:mx-20 2xl:mx-48 py-16 ">
      <div className="grid lg:grid-cols-3 mb-4">
        {dummyData.map((data, index) => {
          const { title, description, icon } = data;
          return (
            <InfoCard
              key={index}
              title={title}
              description={description}
              index={index + 1}
              icon={icon}
            />
          );
        })}
      </div>
    </div>
  );
};

export default InfoSection;
